module.exports = __webpack_public_path__ + "img/hd-header.31007eee.png";